<template>
  <div id="printPositiveReport">
    <div class="section">
      <div class="columns is-variable is-multiline">
        <div class="column is-3 ">
          <figure class="image is-128x128 center-content">
            <img
              class=""
              src="../../assets/imgs/logo-petit-nature.jpg"
              alt=""
            />
          </figure>
        </div>
        <div class="column is-6 center-content">
          <h1 class="title has-text-centered">Rastreabilidade positiva</h1>
        </div>
        <div class="column is-3 center-content">
          <div class="label">
            {{ new Date() | moment("DD/MM/YYYY") }}
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="columns is-variable is-multiline">
        <div class="column is-12 has-text-left">
          <label class="label"
            >Data de referência: {{ date | moment("DD/MM/YYYY") }}</label
          >
        </div>
        <div class="column is-12 has-text-left" v-if="products.length">
          <label class="label">Entregas</label>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Receita</th>
                <th>Lote</th>
                <th>Quantidade entregue</th>
                <th>Tamanho do pacote</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="product in products" :key="product.id">
                <td>{{ product.name }}</td>
                <td>{{ product.batch }}</td>
                <td>{{ product.quantity }}</td>
                <td>{{ product.size }}g</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="column is-12 has-text-left" v-if="pets.length">
          <label class="label">Pets atendidos</label>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Dono</th>
                <th>Pet</th>
                <th>Receita</th>
                <th>Lote</th>
                <th>Pacote recebido</th>
                <th>Quantidade</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pet in pets" :key="pet.id">
                <td>{{ pet.customername }}</td>
                <td>{{ pet.petname }}</td>
                <td>{{ pet.receiptname }}</td>
                <td>{{ pet.batch }}</td>
                <td>{{ pet.size }}g</td>
                <td>{{ pet.sum }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { EventBus } from "../../helpers/EventBus";

export default {
  name: "PrintPositiveReport",
  data: () => ({
    products: [],
    pets: [],
    date: null
  }),
  created() {
    EventBus.$on("print:positiveReport", objToPrint => {
      let that = this;

      this.products = objToPrint.products;
      this.pets = objToPrint.pets;
      this.date = objToPrint.date;

      this.pets.sort((a, b) => {
        if (a.customername > b.customername) {
          return 1;
        } else if (b.customername > a.customername) {
          return -1;
        } else {
          return 0;
        }
      });

      //Used here to ensure that functions will be called only when object has values
      Vue.nextTick(function() {
        that.$htmlToPaper("printPositiveReport");
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("print:positiveReport");
  }
};
</script>

<style scoped></style>
